import React from 'react'
import { Link, useMatch } from 'react-router-dom'

import Badge from '@mui/material/Badge'
import Button from '@mui/material/Button'
import MuiLink from '@mui/material/Link'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { buttonStyling } from './menuStyles'
import NavButton from './navMenuButton'

interface RoestMenuItem {
  name: string
  subMenuItems?: Array<RoestMenuItem>
  href?: string
  internalHref?: string
  target?: string
  badgeCount?: number
}

interface NavbarItemProps {
  navbarItem: RoestMenuItem
}

const NavbarItem = (props: NavbarItemProps): JSX.Element => {
  const routeMatch = useMatch({ path: props.navbarItem.internalHref || '', end: false })

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = (): void => {
    setAnchorEl(null)
  }

  return (
    <>
      {props.navbarItem.subMenuItems && <NavButton onClick={handleOpenMenu}>{props.navbarItem.name}</NavButton>}
      {props.navbarItem.internalHref && (
        <Button
          sx={{
            ...buttonStyling,
            textDecoration: routeMatch ? 'underline' : 'none',
            color: routeMatch ? { xs: 'inherit', md: '#ffffff' } : buttonStyling.color,
          }}
          color="inherit"
          component={Link}
          to={props.navbarItem.internalHref || ''}
        >
          <Badge
            sx={{ pr: 1 }}
            invisible={!props.navbarItem.badgeCount}
            badgeContent={props.navbarItem.badgeCount}
            color="warning"
          >
            {props.navbarItem.name}
          </Badge>
        </Button>
      )}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
        {(props.navbarItem.subMenuItems || []).map((menuItem) => (
          <MenuItem sx={{ p: 0 }} key={menuItem.name} onClick={handleCloseMenu}>
            {menuItem.href ? (
              <MuiLink
                sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}
                color="inherit"
                underline="none"
                href={menuItem.href}
                {...(menuItem.target && { target: menuItem.target, rel: 'noopener noreferrer' })}
              >
                {menuItem.name}
              </MuiLink>
            ) : (
              <MuiLink
                sx={{ pt: 1, pb: 1, pl: 2, pr: 2 }}
                component={Link}
                color="inherit"
                underline="none"
                to={menuItem.internalHref || ''}
              >
                {menuItem.name}
              </MuiLink>
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default NavbarItem
